"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "navigationRef", {
    enumerable: true,
    get: function() {
        return navigationRef;
    }
});
const _createNavigationContainerRef = require("../react-navigation/core/createNavigationContainerRef");
const navigationRef = (0, _createNavigationContainerRef.createNavigationContainerRef)();

//# sourceMappingURL=navigationRef.js.map
